$(document).ready(function() {

  $(document).on('click','.boost-pfs-filter-button', function(){
    var position = $('.boost-pfs-filter-right-col').offset().top - 200;
    $("body, html").animate({
        scrollTop: position
    }, 1000 );
  });
  
  $('.desktop_hamburgermenu .icon-hamburger').mouseenter(function() {
    $(this).parents('.desktop_hamburgermenu').trigger('click');
    // $('.mega-menu').attr('open','true');
  });

$('.mobile-parent-li').click(function(){
	var isActive = jQuery(this).hasClass("active");
	jQuery(".mobile-parent-li").removeClass("active");
	if (!isActive) {
        jQuery(this).toggleClass("active");
	}
	else{
		jQuery(this).removeClass("active");
	}
});
  
  var wi = $(window).width(); 

   if (wi <= 767){
      $( ".custom_left_thumbail" ).insertAfter( $( ".slider-buttons-desktop" ) );
   }

  var previousUrl = document.referrer;
$('.unser-versprechen-url').attr('href',previousUrl);

  if ($(".unavailabel-text").length > 0) {
    $('ul#variant_option_1 .variant__item:first-child').remove();
  }
  
/* Disabled addtocart button */
  $( ".variant__item" ).click(function() {
    $('.product-form__submit').removeClass('firstdisabled');
    $('.product-form__submit').attr('disabled');
    var currenttext = $(this).text();
    //console.log($.trim(currenttext));
    if($.trim(currenttext) == 'Verfügbare Grössen'){
      $('.product-form__submit').addClass('firstdisabled');
      $('.product-form__submit').attr('disabled');
    }
 });
/* Disabled addtocart button */
  
// $('.komfort-icons > div').hover(function() {

//   $('.komfort-icons > div.activeicon').removeClass('activeicon');
    
//     $(this).addClass('activeicon');

//   // $('.komfort-icons > div img').attr('src','https://cdn.shopify.com/s/files/1/0552/7686/3546/files/pointer.png?v=1666857245');
//   //   $('.komfort-icons > div.activeicon img').attr('src','https://cdn.shopify.com/s/files/1/0552/7686/3546/files/pointer-hover.png?v=1666857236');

// });

  $( ".komfort-icons > div" )
  .mouseenter(function() {
    //console.log('Innn');
    $(this).addClass('activeicon');
  })
  .mouseleave(function() {
    //console.log('Outttt');
    $( this ).removeClass('activeicon');
  });
  
  if ($(window).width() < 992) {
   $('.language-selector.desktop-language').remove();
}
else {
   $('.language-selector.mobile-language').remove();
}
  
  $('#aico_map_submit').click();
/*var weglotlang = Weglot.getCurrentLang();
$('.weglot-container ul li#wg-'+weglotlang).addClass('active');
Weglot.on("languageChanged", function(newLang, prevLang) {
  $('.weglot-container ul li.wg-li').removeClass('active');
    $('.weglot-container ul li#wg-'+newLang).addClass('active');
})*/
  
// $(document).on('click', '.wg-li', function() {
// console.log('before');
//   var datal = $(this).data('l');
//   var weglotlang = Weglot.getCurrentLang();
//   console.log(datal,weglotlang);
  
//     $('.wg-li.active').removeClass('active');
//     $(this).addClass('active');

//   console.log('after');
//   });
  var firstchild = $('.optionColor .coloroption1').val();
  $('.color_title span').text(firstchild);

 $( ".optionColor input" ).click(function() {
    var getcolor = $(this).val();
   $('.color_title span').text(getcolor);
 });
  
  // $('#Details-HeaderMenu-1').attr('open',true);
 // $('#Details-menu-drawer-menu-item-1').attr('open',true);

  
    $('.desktop_hamburgermenu').click(function(){
      $('.header__inline-menu').slideToggle();
      $('.desktop_hamburgermenu .icon-close').toggleClass('hamshow');
      $('.desktop_hamburgermenu .icon-hamburger').toggleClass('hamshow');
      $('body').toggleClass('menuhideshow');
      $('.header-wrapper').toggleClass('blackheader');
      $('.header-white-logo').toggleClass('white_logo');
      $('.header-black-logo').toggleClass('black_logo');
      
    });


  $( ".option_for_grosse select" ).change(function() {
        //console.log($( this ).val());
        var selectval = $( this ).val();
        $('.js.product-form__input input').each(function() {
        var radioval = $( this ).val();
    
              if(selectval==radioval){
          
                $(this).prop("checked", true);
                //console.log($( this ).val());
              }
            
          });
        $('#template--14431867732026__main-1-3').val(this.checked);
      // Check input( $( this ).val() ) for validity here
    });


  $('.optionColor input').on('click', function (e) {
    var colrval = $(this).val();
    console.log(colrval);

    $('.need_to_farbe option').each(function() {
        var radioval1 = $( this ).val();
    
              if(colrval==radioval1){
          
                $(this).prop("selected", true);
                //console.log($( this ).val());
              }
            
          });

    
   
    
});
$(".unser-sidebar-li").click(function() {
  $(".unser-sidebar-li.active").removeClass('active');
  $(this).addClass('active');
});

  $(".unser-sidebar-ul li a").click(function() {
    var datatarget = $(this).data('target');
      $('html, body').animate({
          scrollTop: $("."+datatarget).offset().top - 180
      }, 600);
  });

  // $(".unser-sidebar-ul li:nth(0)").click(function() {
  //     $('html, body').animate({
  //         scrollTop: $(".unser-section1-content-wrapper").offset().top - 180
  //     }, 600);
  // });
  // $(".unser-sidebar-ul li:nth(1)").click(function() {
  //     $('html, body').animate({
  //         scrollTop: $(".unser-section2-content-wrapper").offset().top - 180
  //     }, 600);
  // });
  // $(".unser-sidebar-ul li:nth(2)").click(function() {
  //     $('html, body').animate({
  //         scrollTop: $(".unser-section3-content-wrapper").offset().top - 180
  //     }, 600);
  // });
  // $(".unser-sidebar-ul li:nth(3)").click(function() {
  //     $('html, body').animate({
  //         scrollTop: $(".unser-section4-content-wrapper").offset().top - 180
  //     }, 600);
  // });
  // $(".unser-sidebar-ul li:nth(4)").click(function() {
  //     $('html, body').animate({
  //         scrollTop: $(".unser-section5-content-wrapper").offset().top - 180
  //     }, 600);
  // });
  //  $(".unser-sidebar-ul li:nth(5)").click(function() {
  //     $('html, body').animate({
  //         scrollTop: $(".unser-section6-content-wrapper").offset().top - 180
  //     }, 600);
  // });
  // $(".unser-sidebar-ul li:nth(6)").click(function() {
  //     $('html, body').animate({
  //         scrollTop: $(".unser-section7-content-wrapper").offset().top - 180
  //     }, 600);
  // });


 // console.log(window.location.href);
$('.unser-sidebar-li').removeClass('active');
   if(window.location.href.indexOf('#tab1') != -1){
      $('.left-tab-1').addClass('active');
     $('html, body').animate({
          scrollTop: $(".unser-section1-content-wrapper").offset().top - 180
      }, 600);
   }
  if(window.location.href.indexOf('#tab2') != -1){
      $('.left-tab-2').addClass('active');
    $('html, body').animate({
          scrollTop: $(".unser-section2-content-wrapper").offset().top - 180
      }, 600);
   }
  if(window.location.href.indexOf('#tab3') != -1){
      $('.left-tab-3').addClass('active');
    $('html, body').animate({
          scrollTop: $(".unser-section3-content-wrapper").offset().top - 180
      }, 600);
   }
  if(window.location.href.indexOf('#tab4') != -1){
      $('.left-tab-4').addClass('active');
    $('html, body').animate({
          scrollTop: $(".unser-section4-content-wrapper").offset().top - 180
      }, 600);
   }
  if(window.location.href.indexOf('#tab5') != -1){
   
      $('.left-tab-5').addClass('active');
    $('html, body').animate({
          scrollTop: $(".unser-section5-content-wrapper").offset().top - 180
      }, 600);
   }
  if(window.location.href.indexOf('#tab6') != -1){
      $('.left-tab-6').addClass('active');
     $('html, body').animate({
          scrollTop: $(".unser-section6-content-wrapper").offset().top - 180
      }, 600);
   }
  if(window.location.href.indexOf('#tab7') != -1){
      $('.left-tab-7').addClass('active');
     $('html, body').animate({
          scrollTop: $(".unser-section7-content-wrapper").offset().top - 180
      }, 600);
   }
});


$(window).scroll(function(){
   var wi = $(window).width(); 
   if (wi > 989){
     console.log('desktop device');
    var sticky = $('#shopify-section-header'),
        scroll = $(window).scrollTop();
  
    if (scroll >= 100) sticky.addClass('fixedheader');
    else sticky.removeClass('fixedheader');
   }
});

$(window).resize(function() {
  var wi = $(window).width(); 
 if (wi <= 767){
    $( ".custom_left_thumbail" ).insertAfter( $( ".slider-buttons-desktop" ) );
 } else {
    $( ".custom_left_thumbail" ).insertBefore( $( ".custom_right_addtocart" ) );
 }
});

$('.variant__list li').click(function () {
  var $this = $(this); 
  var value = $(this).data('value');
  $('input[type="radio"]').val(value).trigger('click');
  $this.parents('.variant__list-wrapper').toggleClass('hidden');
  if(value == '0'){
    value = $this.text();
  }
  $this.parents('.variant__list-wrapper').siblings('.variant__button').text(value);
  $('.variant__list li').removeClass('selected');
  $this.addClass('selected');
});

$(document).on("click", function(e) {
    if ($(e.target).is(".variant__button") === false) {
     $(".custom_variant_picker .variant__list-wrapper").addClass('hidden');
    }

    if ($(e.target).closest(".header-wrapper--border-bottom.blackheader").length === 0) {
      $(".header-wrapper--border-bottom.blackheader").removeClass('blackheader');
      $("svg.icon.icon-close.hamshow").removeClass('hamshow');
      $("svg.icon.icon-hamburger.hamshow").removeClass('hamshow');
    }
  
});

$(document).on('click','.custom_variant_picker .variant__button',function(){
  var $this = $(this);
  $this.siblings('.variant__list-wrapper').toggleClass('hidden');
});

/*
$(document).mouseup(function(e) {
    var container = $(".custom_variant_picker");
    // if the target of the click isn't the container nor a descendant of the container
    if (!container.is(e.target) && container.has(e.target).length === 0 )
    {
      container.siblings('.variant__list-wrapper').toggleClass('hidden');
      // $('.form-drawer .close').trigger('click');
    }
  });*/

/* Gorgias Settings */
  var initGorgiasChatPromise = (window.GorgiasChat) ? window.GorgiasChat.init() : new Promise(function (resolve) { window.addEventListener('gorgias-widget-loaded', function () { resolve();})});
  initGorgiasChatPromise.then(async () => {
    GorgiasChat.hidePoweredBy(true);
    GorgiasChat.setCustomBusinessHours({
            // Using a timezone from https://en.wikipedia.org/wiki/List_of_tz_database_time_zones
            // Day 1 represents Monday, Day 7 represents Sunday
            timezone: "Europe/Zurich", 
            businessHours: [
                { days: [1, 2, 3, 4, 5], fromTime: "09:30", toTime: "12:30" },
                { days: [1, 2, 3, 5], fromTime: "14:30", toTime: "18:30" },
                { days: [4], fromTime: "14:30", toTime: "19:30" }
            ]
        })
  })